import React from "react";

//const Dashboard = React.lazy(() => import("./components/Dashboard"));
const Dashboard = React.lazy(() => import("./containers/DashboardContainer"));
const OTP = React.lazy(() => import("./containers/OTPContainer"));
const VerifyOTP = React.lazy(() => import("./containers/VerifyOTPContainer"));
const UpdateProfileContainer = React.lazy(() =>
  import("./containers/UpdateProfileContainer")
);

const PromptMsgContainer = React.lazy(()=> import ("./containers/PromptMsgContainer"));

const Login = React.lazy(() => import("./containers/LoginContainer"));
const Category = React.lazy(() => import("./containers/CategoryContainer"));

const ForgotPassword = React.lazy(() =>
  import("./containers/ForgotpasswordContainer")
);

const SignUp = React.lazy(() => import("./containers/SignUpContainer"));
const Feedback = React.lazy(() => import("./containers/FeedbackContainer"));

const MyProfile = React.lazy(() => import("./containers/MyProfileContainer"));
const ResetPwd = React.lazy(() => import("./containers/ResetPwdContainer"));
const CreditNotesContainer = React.lazy(() =>
  import("./containers/CreditNotesContainer")
);
const PaymentsContainer = React.lazy(() =>
  import("./containers/PaymentsContainer")
);
const SupportContainer = React.lazy(() =>
  import("./containers/SupportContainer")
);
const EditProfile = React.lazy(() =>
  import("./containers/EditProfileContainer")
);
const Orders = React.lazy(() => import("./containers/OrdersContainer"));
const NormalOrders = React.lazy(() =>
  import("./containers/NormalOrdersContainer")
);
// const OrderView = React.lazy(() => import("./screens/OrderView"));
const PurchaseReturns = React.lazy(() =>
  import("./containers/PurchaseReturnsContainer")
);
const InvoiceContainer = React.lazy(() =>
  import("./containers/InvoiceContainer")
);
const NotificationContainer = React.lazy(() =>
  import("./containers/NotificationContainer")
);
const routes = [
  { path: "/", exact: true },
  { path: "/dashboard", name: "", component: Dashboard },
  { path: "/login", name: "Login", component: Login },
  { path: "/settings/category", name: "Category", component: Category },
  { path: "/feedback", name: "Feedback", component: Feedback },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: ForgotPassword
  },
  { path: "/signup", name: "SignUp", component: SignUp },

  { path: "/otp", name: "OTP", component: OTP },
  { path: "/verifyotp", name: "VerifyOTP", component: VerifyOTP },
  {
    path: "/updateprofile",
    component: UpdateProfileContainer
  },
  {
    path: "/suspendprompt",
    component: PromptMsgContainer
  },
  { path: "/myprofile", name: "My Profile", component: MyProfile },
  { path: "/resetpassword", name: "Reset Password", component: ResetPwd },
  { path: "/orders", name: "Urgent Orders", component: Orders },
  { path: "/normal-orders", name: "Normal Orders", component: NormalOrders },

  {
    path: "/salesreturns",
    name: "Sales Returns",
    component: PurchaseReturns
  },
  {
    path: "/creditnotes",
    name: "Credit Notes",
    component: CreditNotesContainer
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: InvoiceContainer
  },
  {
    path: "/payments",
    name: "Receipts",
    component: PaymentsContainer
  },
  {
    path: "/support",
    name: "Support Tickets",
    component: SupportContainer
  },
  { path: "/editprofile", name: "Edit Profile", component: EditProfile },
  {
    path: "/notifications",
    name: "Notifications",
    component: NotificationContainer
  }
  // { path: "/orderview", name: "OrderView", component: OrderView }
];

export default routes;
